interface BrandLogoProps {
  className?: string;
}

export function BrandLogo({ className = "h-10 w-[68px]" }: BrandLogoProps) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/images/brand/ks-logo.png"
      alt="KING STUDIO"
      width={68}
      height={40}
      className={className}
    />
  );
}
